<template>
  <modal @closeModal="closeModal" size="modal-md">
    <div slot="header">
      <h4 class="modal-title">MAKE PAYMENT</h4>
    </div>
    <div slot="body">
      <slot name="items"></slot>
      <h6>Choose a payment option.</h6>
      <hr/>
      <div class="payment-options">
        <label class="m-radio m--margin-right-5">
          <input type="radio" v-model="paymentOption" @change="paymentMethodChanged" value="MPESA">
          <img src="../../../static/img/lipa-na-mpesa.jpg">
          <span></span>
        </label>
        <label v-if="cardPaymentAvailable" class="m-radio">
          <input type="radio" v-model="paymentOption" @change="paymentMethodChanged" value="CARD">
          <img src="../../../static/img/credit-card.jpg">
          <span></span>
        </label>
      </div>
      <div v-if="paymentOption === 'MPESA'">
        <hr/>
        <div v-if="mpesaMethod === 'express'" id="stk">
          <p>Pay through MPESA STK PUSH.</p>
          <div class="form-group bg-light m--padding-15" :class="{'has-error': errors.has('phoneNo') }">
            <label>The request will be sent to:</label>
            <input type="text" v-validate="'required'" class="form-control" data-vv-as="phone number" name="phoneNo"
                   v-model="phoneNo">
            <small>
              <em>*The number can be edited</em>
            </small>
            <small v-show="errors.has('phoneNo')" class="help-block">{{ errors.first('phoneNo') }}</small>
          </div>
        </div>
        <div v-if="mpesaMethod === 'paybill'" id="paybill">
          <spinner v-if="!instructions" message="Loading..."></spinner>
          <div v-else id="instructions">
            From your Mobile phone
            <ul>
              <li>Go to safaricom
                <strong class="m--font-boldest2">MPESA</strong> Menu
              </li>
              <li>Select
                <strong class="m--font-boldest2">LIPA NA MPESA</strong>
              </li>
              <li>Select
                <strong class="m--font-boldest2">Pay Bill</strong>
              </li>
              <li>Select
                <strong class="m--font-boldest2">Enter Business Number</strong>
              </li>
              <li>Input
                <strong class="m--font-boldest2">{{ paybillNumber }}</strong>, Click OK
              </li>
              <li>Select
                <strong class="m--font-boldest2">Account No.</strong>
              </li>
              <li>Input
                <strong class="m--font-boldest2">{{ accountNumber }}</strong> , Click OK
              </li>
              <li>Enter Amount
                <strong class="m--font-boldest2">{{ transactionDetails.totalAmount }}</strong>
              </li>
              <li>Enter PIN Number</li>
              <li>Confirm by clicking OK</li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="cardPaymentAvailable && paymentOption === 'CARD'">
        <hr/>
        <p>Pay securely through your credit/debit card.</p>
        <table v-if="cards.length > 0" class="table table-striped table-bordered" style="margin-bottom: 5px">
          <thead>
          <tr>
            <th width="5%"></th>
            <th>Card Number</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="card in cards" :key="card.id">
            <td>
              <label class="m-radio">
                <input type="radio" @change="cardSelected" v-model="cardToken" :value="card.cardToken">
                <span></span>
              </label>
            </td>
            <td>{{ card.cardNo }}</td>
          </tr>
          </tbody>
        </table>
        <div v-if="errorMessage" class="text-danger">
          Please select or add a card to pay.
        </div>
        <div v-if="cards.length === 0">
          No cards added.
          <router-link :to="{ name:'billing' }" class="btn btn-primary">
            <i class="fa fa-plus"></i> Add Card
          </router-link>
        </div>
      </div>
      <socket v-if="socket" :backdrop="backdrop" :payment-id="paymentId" @paymentSuccessful="paymentSuccessful"
              @paymentError="paymentError" @connectionClosed="connectionClosed"
              message="Waiting for payment..."></socket>
    </div>
    <div v-if="(mpesaMethod == 'express' && !socket) || (paymentOption == 'CARD' && cards.length > 0)" slot="buttons">
      <button type="button" class="btn btn-success" :class="{'m-loader m-loader--light m-loader--right':loading}"
              data-dismiss="modal" @click="proceedToPay">
        <i class="fa fa-shopping-cart"></i> Proceed
      </button>
    </div>
  </modal>
</template>
<script>
  import modal from "../Modal";
  import api from "../../api";
  import helper from "../../helpers";
  import socket from "../websocket/Socket";
  import spinner from "vue-simple-spinner";
  import config from "../../config"

  export default {
    name: "Payment",
    props: {
      transactionDetails: {},
      cardTxType: "",
      mpesaTxType: ""
    },
    data() {
      return {
        cards: [],
        cardToken: "",
        paymentId: "",
        instructions: false,
        socket: false,
        loading: false,
        backdrop: false,
        errorMessage: false,
        cardPaymentAvailable: '',
        paymentOption: "MPESA",
        mpesaMethod: "express",
        paybillNumber: "",
        accountNumber: "",
        phoneNo: JSON.parse(window.localStorage.getItem("user")).phoneNo,
        token: this.$store.state.token || window.localStorage.getItem("token")
      };
    },
    components: {
      modal,
      socket,
      spinner
    },
    methods: {
      cardSelected() {
        if (this.cardToken.length > 0) {
          this.errorMessage = false;
        } else {
          this.errorMessage = true;
        }
      },
      paymentMethodChanged() {
        if (this.paymentOption === "CARD" && this.mpesaMethod === "paybill") {
          this.socket = false;
        } else if (this.mpesaMethod === "express") {
          this.socket = false;
        }
      },
      toggleLoading() {
        this.loading = !this.loading;
      },
      proceedToPay() {
        if (this.paymentOption === "MPESA" && this.mpesaMethod === "express") {
          this.payWithMpesa();
        } else if (this.paymentOption === "CARD") {
          this.payWithCard();
        }
      },
      payWithMpesa() {
        this.$validator.validate("phoneNo", this.phoneNo).then(valid => {
          if (valid) {
            let data = this.transactionDetails;
            data.phoneNo = this.phoneNo;
            this.completePayment(this.mpesaTxType, data);
          } else {
            console.log("Invalid Phone Number");
          }
        });
      },
      payWithCard() {
        if (this.cardToken.length === 0) {
          this.errorMessage = true;
          return false;
        }
        let data = this.transactionDetails;
        data.cardToken = this.cardToken;
        this.completePayment(this.cardTxType, data);
      },
      completePayment(txType, data) {
        this.toggleLoading();
        api
          .request(txType, data)
          .then(response => {
            if (response.data.status === "00") {
              this.backdrop = true;
              // Change this later to just data from response
              if (null !== response.data.paymentId) {
                var paymentIdObj = {paymentId: response.data.paymentId};
                this.paymentId = JSON.stringify(paymentIdObj);
              } else {
                this.paymentId = '{"paymentId": "123"}';
              }
              console.log("PaymentID: " + this.paymentId);
              this.socket = true;
            } else {
              this.$emit("closePaymentModal");
              helper.errorAlert(response.data.message);
            }
          })
          .catch(error => {
            this.$emit("closePaymentModal");
            helper.errorAlert("An error occured. Please try again later.");
          });
      },
      paymentSuccessful() {
        this.$emit("closePaymentModal");
        helper.successAlert("Payment received successfully.");
      },
      paymentError(error) {
        helper.errorAlert(error);
        this.$emit("closePaymentModal");
      },
      connectionClosed() {
        this.$emit("closePaymentModal");
        helper.warningAlert(
          "Please check payment history to confirm payment.",
          "Timeout"
        );
      },
      getCards() {
        const txType = "get-cards";
        api
          .request(txType, {token: this.token})
          .then(response => {
            if (response.data.status === "00") {
              this.cards = response.data.cards;
            } else {
              this.cards = [];
              console.log(response.data.message);
            }
          })
          .catch(error => {
            console.log(error.response);
          });
      },
      closeModal() {
        if (!this.socket) {
          return this.$emit("closePaymentModal");
        }
        helper
          .questionAlert(
            "We are still waiting to confirm payment.",
            "Are you sure?"
          )
          .then(result => {
            if (result.value) {
              this.$emit("closePaymentModal");
            }
          });
      },
      initialize() {
        const txType = "get-counties";
        api.request(txType, {token: this.token}).then(result => {
          if (result.data.status === '00') {
            let activeCounty = result.data.counties[0];
            this.paybillNumber = activeCounty.payBill;
            this.mpesaMethod = activeCounty.payBillMode;
            if (this.mpesaMethod === "paybill") {
              this.socket = true;
              this.getAccountNumber(this.accountTxType, this.transactionDetails);
            }
          } else {
            console.log(result.data.message);
          }
        });
      },
      getAccountNumber(txType, data) {
        this.instructions = false;
        this.socket = false;
        api
          .request(txType, data)
          .then(response => {
            if (response.data.status === "00") {
              this.instructions = true;
              this.socket = true;
              this.accountNumber = response.data.accountNumber;
            } else {
              // remove this simulation later
              this.instructions = true;
              this.socket = true;
              this.accountNumber = helper.randomNumber(5);
            }
          })
          .catch(() => {
            // remove this simulation later
            this.instructions = true;
            this.socket = true;
            this.accountNumber = helper.randomNumber(5);
          });
      }
    },
    mounted: function () {
      this.initialize();
      this.cardPaymentAvailable = config.cardPaymentAvailable;
      if (this.cardPaymentAvailable) {
        this.getCards();
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/checkout/Payment.vue